/**
 * Simple alerts polling service following the existing codebase patterns
 * Polls the GetAlerts API every 60 seconds starting immediately
 */
import { apiRequest } from './apiMiddleware';
import { API_GATEWAY_PROCESS_NAME } from '../utils/constants';

/**
 * Simple alerts polling class
 */
class AlertsPolling {
  private pollingInterval: NodeJS.Timeout | null = null;
  private isPolling = false;

  /**
   * Start polling the GetAlerts API every 60 seconds starting immediately
   */
  startPolling(): void {
    if (this.isPolling) {
      console.log('[AlertsPolling] Polling already active');
      return;
    }

    this.isPolling = true;
    console.log('[AlertsPolling] Starting alerts polling - will fetch immediately and then every 60 seconds');

    // Make the first call immediately
    this.fetchAlerts();

    // Then set up the regular 60-second interval
    this.pollingInterval = setInterval(() => {
      this.fetchAlerts();
    }, 60000); // 60 seconds
  }

  /**
   * Stop polling
   */
  stopPolling(): void {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    this.isPolling = false;
    console.log('[AlertsPolling] Polling stopped');
  }

  /**
   * Check if polling is active
   */
  isPollingActive(): boolean {
    return this.isPolling;
  }

  /**
   * Fetch alerts using the standard apiRequest pattern and log the response
   */
  private async fetchAlerts(): Promise<void> {
    try {
      console.log('[AlertsPolling] Fetching alerts...');
      
      const requestPayload = {
        resourcePath: '/getAlerts',
        httpMethod: 'post',
        processName: API_GATEWAY_PROCESS_NAME,
        requestBody: {}
      };

      const response = await apiRequest(requestPayload);
      console.log('[AlertsPolling] Alerts response:', response);
    } catch (error) {
      console.error('[AlertsPolling] Error fetching alerts:', error);
    }
  }
}

// Create and export singleton instance
export const alertsPolling = new AlertsPolling();
